import * as React from 'react';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  Tooltip as TooltipPrimitive,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/features/ui/primitives/tooltip';

interface TooltipProps {
  text: string;
  children?: React.ReactNode;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
}

export const Tooltip: React.FC<TooltipProps> = ({
  text,
  children,
  className,
  side = 'top',
  align = 'center',
  delayDuration = 400,
}) => {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <TooltipPrimitive>
        <TooltipTrigger asChild>
          <span className={cn('cursor-help', className)}>{children}</span>
        </TooltipTrigger>
        <TooltipContent side={side} align={align}>
          <p>{text}</p>
        </TooltipContent>
      </TooltipPrimitive>
    </TooltipProvider>
  );
};

// Convenience component for info tooltips with icon
interface InfoTooltipProps {
  text: string;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  className,
  side = 'top',
  align = 'center',
}) => {
  return (
    <Tooltip text={text} className={className} side={side} align={align}>
      <Info className="h-4 w-4 text-gray-400 hover:text-gray-600 transition-colors" />
    </Tooltip>
  );
};
